import React, { useEffect, useState } from "react";
import { Layout, Row, Col, Breadcrumb, Steps, Button, message, Spin, Card, Form, Calendar } from "antd";
import { Controller, useForm } from "react-hook-form";

import { DateField, InputField, ReactSelectField } from "../../../atoms/FormElement";
import { getBUList } from "../../Contracts/ducks/actions";
import dayjs from "dayjs";
import { dateFormat, datePlaceholderddmmyyFormat } from "../../BookingForm/components/utils";
import axios from "../../../../utils/axiosInceptor";
import { addNewSingleProperty } from "../../../../configs/constants";
import { getConfigData } from "../ducks/actions";
import { useDispatch, useSelector } from "react-redux";
import { getLandlordUsers } from "../../BookingForm/ducks/actions";
import { useApiWithFilters } from "../../../../hooks/search/useApiWithFilters";
import { getBeneficiaries } from "./ducks/actions/getOwner";

var _ = require("lodash");
const AddSingleProperty = (props) => {
  const configKeys = ["locationlist", "emiratesList", "nationalityList"];
  const configData = useSelector((state: any) => state.dashboard.configData);
  const landlordUsers = useSelector((state: any) => state.leasingForm.landlordUsers);
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm();
  const [buOptions, setBUOptions] = useState([]);
  const [beneficiariesOptions, setBeneficiariesOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch: any = useDispatch();

  const {
    data: ownersResult,
    loading: isLoadingOwners,
    fetchData: fetchOwners,
  } = useApiWithFilters({
    apiUrl: "/property/owner",
    method: "GET",
    initialParams: { limit: 20000, page: 1 },
  });

  const dataSubmit = async (value) => {
    setIsSubmitting(true);
    let payload = {
      businessUnitName: value?.businessUnitName?.label,
      businessUnitId: value?.businessUnitName?.value,
      propertyReferenceNumber: value?.propertyReferenceNumber,
      buildingName: value?.buildingName,
      makaniNumber: value?.makaniNumber,
      propertyCode: value?.propertyCode,
      propertyNumber: value?.propertyNumber,
      ownerNumber: value?.owner?.ownerNumber || value?.ownerNumber,
      ownerName: value?.owner?.label,
      ownerId: value?.owner?.ownerId,
      beneficiaryId: value?.beneficiary?.value,
      beneficiaryName: value?.beneficiary?.label,
      effectiveStartDate: value?.effectiveStartDate,
      effectiveEndDate: value?.effectiveEndDate,
      address: {
        addressLine1: value.addressLine1,
        addressLine2: value.addressLine2,
        addressLine3: "",
        community: value.community?.value,
        emirates: value.city?.value,
        country: value.country?.value,
        longitude: value.longitude,
        latitude: value.latitude,
      },

      erpLaName: value?.propertyAdminName?.label,
      erpLaEmail: value?.propertyAdminName?.value,
    };

    let url = addNewSingleProperty;
    try {
      const response = await axios.post(url, payload);
      const { data } = response;

      if (data?.code === 201) {
        message.success("Property data has been added successfully");
        props?.onSubmit();
        props?.setVisible(false);
      }
    } catch (error) {
      message.error(error.response?.data?.error || "An error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    (async () => {
      const res = await getBUList();

      let unitOptions = [];
      res?.length > 0 &&
        res?.forEach((element) => {
          unitOptions.push({
            value: element.businessUnitId,
            label: element.businessUnitName,
          });
        });
      setBUOptions(unitOptions);
    })();
    dispatch(getConfigData(configKeys.join(",")));
    dispatch(getLandlordUsers(""));
    fetchOwners();

    // Set default dates
    const startOfMonth = dayjs().startOf("month");
    const endDate = startOfMonth.add(10, "year");
    setValue("effectiveStartDate", startOfMonth);
    setValue("effectiveEndDate", endDate);
  }, []);

  const getBeneficiariesOption = async (ownerId) => {
    if (!ownerId) {
      setBeneficiariesOptions([]);
      return;
    }
    try {
      const data = await getBeneficiaries(ownerId);
      if (data?.length > 0) {
        let result = _.map(data, (item) => ({
          value: item?.beneficiaryId,
          label: item?.beneficiaryName,
        }));
        setBeneficiariesOptions(result);
      } else {
        setBeneficiariesOptions([]);
      }
    } catch (error) {
      setBeneficiariesOptions([]);
    }
  };

  const handleOwnerChange = (selectedOwner) => {
    setValue("owner", selectedOwner);
    setValue("beneficiary", null);
    if (selectedOwner?.ownerId) {
      getBeneficiariesOption(selectedOwner.ownerId);
    } else {
      setBeneficiariesOptions([]);
    }
  };

  return (
    <Spin spinning={isSubmitting} tip="Submitting...">
    <Form layout="vertical" className="bf-main" onFinish={handleSubmit(dataSubmit)}>
      <Card
        title="Property Details"
        bordered={false}
        style={{
          marginBottom: 16,
          boxShadow: "none",
          border: "1px solid #f0f0f0",
          paddingBottom: "0px",
        }}
        bodyStyle={{ paddingBottom: "0px" }}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <InputField
              isRequired={true}
              label="Building Name"
              fieldname="buildingName"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Building Name",
              }}
              rules={{ required: "Building name is required" }}
              validate={errors.buildingName && "error"}
              validMessage={errors.buildingName && errors.buildingName.message}
            />
          </Col>

          <Col span={8}>
            <DateField
              control={control}
              isRequired={true}
              setValue={setValue}
              label="Effective Start Date"
              fieldname="effectiveStartDate"
              validate={errors.effectiveStartDate && "error"}
              rules={{
                required: "Enter effective start date",
              }}
              onChange={(date) => {
                if (date) {
                  setValue("effectiveStartDate", dayjs(date));
                  // Auto-update end date to start date + 10 years if end date is not manually changed
                  const newEndDate = dayjs(date).add(10, "year");
                  const currentEndDate = control._formValues?.effectiveEndDate;
                  if (!currentEndDate || dayjs(currentEndDate).isSame(dayjs().startOf("month").add(10, "year"))) {
                    setValue("effectiveEndDate", newEndDate);
                  }
                } else setValue("effectiveStartDate", "");
              }}
              iProps={{
                format: datePlaceholderddmmyyFormat,
                placeholder: datePlaceholderddmmyyFormat,
              }}
              valueGot={dateFormat(dayjs().startOf("month"))}
              validMessage={errors.effectiveStartDate && errors.effectiveStartDate.message}
            />
          </Col>

          <Col span={8}>
            <DateField
              control={control}
              isRequired={true}
              setValue={setValue}
              label="Effective End Date"
              fieldname="effectiveEndDate"
              validate={errors.effectiveEndDate && "error"}
              rules={{
                required: "Enter effective end date",
              }}
              onChange={(date) => {
                if (date) {
                  setValue("effectiveEndDate", dayjs(date));
                } else setValue("effectiveEndDate", "");
              }}
              iProps={{
                format: datePlaceholderddmmyyFormat,
                placeholder: datePlaceholderddmmyyFormat,
              }}
              valueGot={dateFormat(dayjs().startOf("month").add(10, "year"))}
              validMessage={errors.effectiveEndDate && errors.effectiveEndDate.message}
            />
          </Col>

          <Col span={8}>
            <InputField
              isRequired={true}
              label="Property Reference Number"
              fieldname="propertyReferenceNumber"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Property Reference Number",
              }}
              rules={{ required: "Property reference number is required" }}
              validate={errors.propertyReferenceNumber && "error"}
              validMessage={errors.propertyReferenceNumber && errors.propertyReferenceNumber.message}
            />
          </Col>

          <Col span={8}>
            <InputField
              isRequired={false}
              label="Property Code"
              fieldname="propertyCode"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Property Code",
              }}
            />
          </Col>

          <Col span={8}>
            <InputField
              isRequired={true}
              label="Property Number"
              fieldname="propertyNumber"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Property Number",
              }}
              rules={{ required: "Property number is required" }}
              validate={errors.propertyNumber && "error"}
              validMessage={errors.propertyNumber && errors.propertyNumber.message}
            />
          </Col>

          <Col span={8}>
            <ReactSelectField
              isRequired={true}
              label="Business Unit Name"
              fieldname="businessUnitName"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Select Business Unit Name",
              }}
              selectOption={buOptions}
              rules={{ required: "Please select business unit name" }}
              validate={errors.businessUnitName && "error"}
              validMessage={errors.businessUnitName && errors.businessUnitName.message}
            />
          </Col>

          <Col span={8}>
            <ReactSelectField
              control={control}
              isRequired={true}
              setValue={setValue}
              label="Property Admin Name"
              fieldname="propertyAdminName"
              initValue=""
              selectOption={
                landlordUsers?.length > 0
                  ? landlordUsers.map((user) => ({
                      label: user.name,
                      value: user.email,
                    }))
                  : []
              }
              iProps={{ placeholder: "Select Property Admin Name" }}
              rules={{ required: "Please select property admin name" }}
              validate={errors.propertyAdminName && "error"}
              validMessage={errors.propertyAdminName && errors.propertyAdminName.message}
            />
          </Col>
        </Row>
      </Card>

      <Card title="Address Details" bordered={false} style={{ marginTop: 16 }} bodyStyle={{ paddingBottom: "0px" }}>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <InputField
              isRequired={true}
              label="Address Line 1"
              fieldname="addressLine1"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Enter address Line 1",
              }}
              rules={{ required: "Please enter address Line 1" }}
              validate={errors.addressLine1 && "error"}
              validMessage={errors.addressLine1 && errors.addressLine1.message}
            />
          </Col>
          <Col span={8}>
            <InputField
              isRequired={false}
              label="Address Line 2"
              fieldname="addressLine2"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Enter address Line 2",
              }}
            />
          </Col>
          <Col span={8}>
            <ReactSelectField
              isRequired={true}
              label="Community"
              fieldname="community"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Select Community",
              }}
              selectOption={_.map(configData?.locationlist?.sublocation, (item, key) => ({
                value: item,
                label: item,
              }))}
              rules={{ required: "Please select community" }}
              validate={errors.community && "error"}
              validMessage={errors.community && errors.community.message}
            />
          </Col>
          <Col span={8}>
            <ReactSelectField
              isRequired={true}
              label="City"
              fieldname="city"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Select City",
              }}
              selectOption={_.map(configData?.emiratesList, (item) => ({
                value: item,
                label: item,
              }))}
              rules={{ required: "Please select city" }}
              validate={errors.city && "error"}
              validMessage={errors.city && errors.city.message}
            />
          </Col>
          <Col span={8}>
            <ReactSelectField
              isRequired={true}
              label="Country"
              fieldname="country"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Select Country",
              }}
              selectOption={_.map(["United Arab Emirates"], (item) => ({
                value: item,
                label: item,
              }))}
              rules={{ required: "Please enter country" }}
              validate={errors.country && "error"}
              validMessage={errors.country && errors.country.message}
            />
          </Col>
          <Col span={8}>
            <InputField
              isRequired={true}
              label="Longitude"
              fieldname="longitude"
              control={control}
              initValue=""
              iProps={{
                placeholder: "55.1522",
              }}
              rules={{ required: "Longitude is required" }}
              validate={errors.longitude && "error"}
              validMessage={errors.longitude && errors.longitude.message}
            />
          </Col>
          <Col span={8}>
            <InputField
              isRequired={true}
              label="Latitude"
              fieldname="latitude"
              control={control}
              initValue=""
              iProps={{
                placeholder: "25.0554",
              }}
              rules={{ required: "Latitude is required" }}
              validate={errors.latitude && "error"}
              validMessage={errors.latitude && errors.latitude.message}
            />
          </Col>
          <Col span={8}>
            <InputField
              isRequired={false}
              label="Makani No"
              fieldname="makaniNumber"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Makani No",
              }}
            />
          </Col>
        </Row>
      </Card>

      <Card title="Ownership" bordered={false} style={{ marginTop: 16 }} bodyStyle={{ paddingBottom: "0px" }}>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <ReactSelectField
              isRequired={false}
              label="Owner"
              fieldname="owner"
              control={control}
              initValue=""
              setValue={setValue}
              iProps={{
                placeholder: "Select Owner",
              }}
              selectOption={_.map(ownersResult?.result?.data || [], (item) => ({
                value: item?.name,
                label: item?.name,
                ownerId: item?.ownerId,
                ownerNumber: item?.number,
                ownerNationality: item?.nationality,
              }))}
              onChange={handleOwnerChange}
            />
          </Col>
          <Col span={8}>
            <ReactSelectField
              isRequired={false}
              label="Beneficiary"
              fieldname="beneficiary"
              control={control}
              initValue=""
              setValue={setValue}
              iProps={{
                placeholder: "Select Beneficiary",
              }}
              selectOption={beneficiariesOptions}
            />
          </Col>
        </Row>
      </Card>

      <Col span={24}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "30px",
          }}
        >
          <Button
            onClick={() => props?.setSinglePropertyFlag(false)}
            htmlType="submit"
            type="default"
            size="large"
            className="csv_publish"
          >
            Back
          </Button>
          <Button 
            htmlType="submit" 
            type="primary" 
            size="large" 
            className="csv_publish"
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </div>
      </Col>
    </Form>
    </Spin>
  );
};

export default AddSingleProperty;
